(() => {
  if (window.ladyElseSections) return;
  window.ladyElseSections = true;
  const instances = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 749px)');
  const designMode = Boolean(window.Shopify?.designMode);
  const behaviour = () => reduced.matches ? 'auto' : 'smooth';
  let headerObserver;
  const setupHeader = () => {
    const header = document.querySelector('.shopify-section--header');
    if (!header) return;
    const update = () => {
      const sticky = getComputedStyle(header).position === 'sticky';
      const height = sticky ? header.getBoundingClientRect().height + (parseFloat(getComputedStyle(header).top) || 0) : 0;
      document.documentElement.style.setProperty('--le-header-height', `${height}px`);
    };
    headerObserver?.disconnect();
    headerObserver = new ResizeObserver(update);
    headerObserver.observe(header);
    update();
  };
  const initialise = root => {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const entry = { controller, observers: [], animations: [], frame: 0 };
    instances.set(root, entry);
    const options = { signal: controller.signal };
    const listen = (target, type, fn, extra = {}) => target?.addEventListener(type, fn, { ...options, ...extra });
    const rail = root.querySelector('.le-product-rail');
    if (rail) {
      const prev = root.querySelector('[data-le-prev]');
      const next = root.querySelector('[data-le-next]');
      const update = () => {
        const max = rail.scrollWidth - rail.clientWidth;
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max - 2;
        root.style.setProperty('--le-rail-progress', max > 1 ? Math.min(1, (rail.scrollLeft + rail.clientWidth) / rail.scrollWidth) : 1);
      };
      const move = direction => {
        const card = rail.querySelector('.le-product-item');
        const step = card ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 16) : rail.clientWidth;
        rail.scrollBy({left: direction * step, behavior: behaviour()});
      };
      listen(prev, 'click', () => move(-1));
      listen(next, 'click', () => move(1));
      listen(rail, 'scroll', update, { passive: true });
      listen(rail, 'keydown', event => {
        if (event.target !== rail || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();move(event.key === 'ArrowRight' ? 1 : -1);
      });
      const resize = new ResizeObserver(update);resize.observe(rail);entry.observers.push(resize);update();
    }
    if (root.hasAttribute('data-le-tech')) {
      const panels = [...root.querySelectorAll('.le-tech-panel')];
      const links = [...root.querySelectorAll('[data-le-scene-link]')];
      const scenes = root.querySelector('.le-tech-scenes');
      const panelResize = new ResizeObserver(entries => entries.forEach(({target}) => target.style.setProperty('--le-panel-height', `${target.offsetHeight}px`)));
      panels.forEach(panel => panelResize.observe(panel));entry.observers.push(panelResize);
      const setCurrent = index => links.forEach((link, i) => i === index ? link.setAttribute('aria-current', 'true') : link.removeAttribute('aria-current'));
      const select = (index, focus = false) => {
        const panel = panels[index];if (!panel) return;
        if (mobile.matches) scenes.scrollTo({left: panel.offsetLeft, behavior: behaviour()});
        else {
          const gap = parseFloat(getComputedStyle(scenes).rowGap) || 0;
          const before = panels.slice(0, index).reduce((sum, item) => sum + item.offsetHeight + gap, 0);
          const top = scenes.getBoundingClientRect().top + window.scrollY + before - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--le-header-height')) || 80) - 20;
          window.scrollTo({top, behavior: behaviour()});
        }
        setCurrent(index);
        if (focus) panel.focus({preventScroll:true});
      };
      links.forEach((link, i) => listen(link, 'click', event => { event.preventDefault(); select(i, true); }));
      listen(scenes, 'scroll', () => {
        if (!mobile.matches || !panels.length) return;
        const index = panels.reduce((best, panel, i) => Math.abs(panel.offsetLeft - scenes.scrollLeft) < Math.abs(panels[best].offsetLeft - scenes.scrollLeft) ? i : best, 0);
        setCurrent(index);
      }, {passive:true});
      listen(scenes, 'keydown', event => {
        if (event.target !== scenes || !mobile.matches || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const current = links.findIndex(link => link.getAttribute('aria-current') === 'true');
        select(Math.max(0, Math.min(panels.length - 1, current + (event.key === 'ArrowRight' ? 1 : -1))));
      });
      listen(root, 'shopify:block:select', event => {
        const panel = event.target.closest('.le-tech-panel');const i = panels.indexOf(panel);if(i >= 0) select(i);
      });
      setCurrent(0);
    }
    if (root.hasAttribute('data-le-marquee')) {
      let visible = true;
      const update = () => root.dataset.lePaused = String(!visible || document.hidden || designMode || reduced.matches);
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting;update(); });
      observer.observe(root);entry.observers.push(observer);
      listen(document, 'visibilitychange', update);listen(reduced, 'change', update);update();
    }
    if (designMode || root.dataset.leMotion !== 'true') return;
    const cancelAnimations = () => {
      if (!reduced.matches) return;
      entry.animations.forEach(animation => animation.cancel());
      root.style.removeProperty('--le-pan');
    };
    listen(reduced, 'change', cancelAnimations);
    if (reduced.matches) return;
    const targets = root.hasAttribute('data-le-banner') ? [...root.querySelectorAll('.le-banner-copy > *')] : [...root.querySelectorAll('.le-section-heading,.le-shop-heading,.le-goal,.le-product-item,.le-faq-grid>div:first-child,.le-close-grid>div,.le-story-intro')];
    if (targets.length) {
      const observer = new IntersectionObserver(entries => {
        for (const item of entries) if (item.isIntersecting) {
          observer.unobserve(item.target);
          if (reduced.matches) continue;
          const i = targets.indexOf(item.target);
          const animation = item.target.animate([{opacity:.15,transform:'translateY(28px)'},{opacity:1,transform:'translateY(0)'}],{duration:850,delay:Math.min(i%4*70,210),easing:'cubic-bezier(.16,1,.3,1)',fill:'none'});
          entry.animations.push(animation);
        }
      },{threshold:.08});
      targets.forEach(target => observer.observe(target));entry.observers.push(observer);
    }
    if (root.hasAttribute('data-le-banner')) {
      let visible = false;
      const draw = () => {
        entry.frame = 0;
        if (!visible || reduced.matches || document.hidden || (mobile.matches && root.dataset.leMobileSeparate === 'true')) return;
        const bounds = root.getBoundingClientRect();
        const depth = parseFloat(getComputedStyle(root).getPropertyValue('--le-depth')) || 0;
        const progress = Math.max(-1,Math.min(1, -bounds.top / (bounds.height + innerHeight)));
        root.style.setProperty('--le-pan', `${progress * depth * (mobile.matches ? .35 : 1)}px`);
      };
      const schedule = () => { if (!entry.frame && visible) entry.frame = requestAnimationFrame(draw); };
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting;schedule(); });
      observer.observe(root);entry.observers.push(observer);
      listen(window, 'scroll', schedule, {passive:true});listen(window,'resize',schedule,{passive:true});listen(document,'visibilitychange',schedule);
    }
  };
  const scan = (scope = document) => {
    if (scope.matches?.('[data-le-section]')) initialise(scope);
    scope.querySelectorAll('[data-le-section]').forEach(initialise);
  };
  const dispose = scope => {
    for (const [root, entry] of instances) if (scope === root || scope.contains(root)) {
      entry.controller.abort();entry.observers.forEach(observer => observer.disconnect());entry.animations.forEach(animation => animation.cancel());cancelAnimationFrame(entry.frame);instances.delete(root);
    }
  };
  const boot = () => { setupHeader();scan(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});else boot();
  document.addEventListener('shopify:section:load', event => { setupHeader();scan(event.target); });
  document.addEventListener('shopify:section:unload', event => dispose(event.target));
  document.addEventListener('shopify:block:select', event => { const detail = event.target.closest?.('details');if(detail) detail.open = true; });
})();
